import { Bell, Rocket, VenetianMask } from 'lucide-react'

import { createAction } from '@/index'

export const NOTIFICATIONS = createAction({
  label: 'Notifications',
  icon: Bell,
  action: () => {},
})

export const CHANGELOG = createAction({
  label: 'Changelog',
  icon: Rocket,
  action: () => {},
})

export const IMPERSONATE = createAction({
  label: 'Impersonate',
  icon: VenetianMask,
  devOnly: true,
  action: ({ userContext }) => {
    userContext.setShowImpersonationModal(true)
  },
})
